export default __webpack_public_path__ + "4da9519318614c31a3227e678de4a2ca.png";